export const data = [
    {
        name: 'Mumbai',
        address: "Unit Nos. 1101 and 1102, 11th Floor in C Wing “Godrej Coliseum” C.T.S. No.638(part) of Kurla Village, Lokmanya Pan Bazaar, behind Everard Nagar, Sion (East), Mumbai – 400 022" 
    },
    {
        name: 'Sion',
        address: "Unit Nos. 1101 and 1102, 11th Floor in C Wing “Godrej Coliseum” C.T.S. No.638(part) of Kurla Village, Lokmanya Pan Bazaar, behind Everard Nagar, Sion (East), Mumbai – 400 022" 
    },
    {
        name: 'New Delhi',
        address: "CoreCare Technologies India Pvt Ltd PNR House, R 5 Green Park Market New Delhi" 
    },
    {
        name: 'Kolkata',
        address: "SHRACHI TOWER, 5th Floor, Plot I-25 B/1, Kolkata East Calcutta Area Development ipal Premises No. 686, Anandapur, Kolkata – 700 107" 
    }
]